import React, { useState } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { OptionsObject, SnackbarKey, useSnackbar, VariantType } from 'notistack';
import { useStores } from 'src/stores/rootStore';
import { Message } from 'src/stores/models/messageModels';
import { Button } from '@material-ui/core';

export const Notifier = observer(() => {

    const { uiStateStore } = useStores();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [ visibleMessages ] = useState<Message[]>([]);

    const getMessage = (internalKey: string): Message => {
        return visibleMessages.find(x => x.internalKey === internalKey) as Message;
    }

    const getSnackbarKey = (internalKey: string): SnackbarKey => {
        return getMessage(internalKey).messageKey as SnackbarKey;
    }

    const handleClose = (internalKey: string) => {
        closeSnackbar(getSnackbarKey(internalKey));
        removeMessage(internalKey)
    }

    const addCloseButton = (message: Message) => {
        if (!message.action) {
            message.action = <></>
        }

        return (
            <>
                {message.action}
                <Button color="default" size="small" onClick={(_event) => handleClose(message.internalKey)}>
                    X
                </Button>
            </>
        );
    }

    const addMessage = (newMessage: Message) => {        
        visibleMessages.push(newMessage);
    }

    const removeMessage = (internalKey: string) => {
        const indexOf = visibleMessages.indexOf(getMessage(internalKey))
        visibleMessages.splice(indexOf, 1);
    }

    autorun(() => {

        if (uiStateStore.messages.length > 0) {
            const message = uiStateStore.messages.pop() as Message;

            if (message.persistent) {
                message.action = addCloseButton(message)
            }

            const options = {

                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                },

                action: message.action,
                variant: message.kind as VariantType,
                persist: message.persistent

            } as OptionsObject;

            message.messageKey = enqueueSnackbar(message.content, options);            

            if (message.persistent) {
                addMessage(message);
            }            
        }

    });

    return null;

});